import { render } from "./ConferenceManagementWrapper.vue?vue&type=template&id=7bcbfb2b"
import script from "./ConferenceManagementWrapper.vue?vue&type=script&lang=js"
export * from "./ConferenceManagementWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__